import React from "react";
import LogicalFiltersDropDown from "./LogicalFiltersDropDown";
import { Grid } from "@mui/material";
import reportbuilder from "../ReportBuilder.module.css";
import SelectedFilterLists from "./SelectedFilterLists";
const Logical = () => {
  return (
    <Grid
      xs={12}
      sx={{ display: "flex", flexDirection: "row", height: "28vh"}}
    >
      {/* outer grid height= */}
      <Grid xs={12} sx={{height: "5vh" }}>
        <LogicalFiltersDropDown />
        <Grid
          xs={12}
          className={reportbuilder.logic}
        >
          <SelectedFilterLists />
        </Grid>
      </Grid>
    </Grid>
  );
};

export default Logical;
